/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import User from './User';
import NewUser from './_userExample.json';
import { UserActions } from './UserActions';
import { RootState } from '../reducer';
import { UserClient } from 'Api/generated';
import { CompanyDataActions } from 'CompanyData/CompanyDataActions';
import { Dispatch } from '@reduxjs/toolkit';
import { AllowedRoles } from 'Contexts/Auth';

const newUser: UserClient = NewUser;

type StateProps_t = ReturnType<typeof mapStateToProps>;
type DispatchProps_t = ReturnType<typeof mapDispatchToProps>;

type UserDataProps = StateProps_t & DispatchProps_t;

const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

const UserList = ({ users, companies, QueryUsers, QueryCompanys }: UserDataProps) => {
  // const dispatch = useDispatch();

  useEffect(() => {
    QueryCompanys();
    QueryUsers();
  }, [QueryCompanys, QueryUsers]);

  const keys = getKeys(users.Users).sort((a, b) =>
    a.toString().localeCompare(b.toString(), undefined, { sensitivity: 'base' }),
  );

  return (
    <AllowedRoles roles={['SuperAdmin', 'Admin']}>
      <div>
        <ul>
          {keys.map((key) => {
            return (
              <User
                key={users.Users?.[key]?.Id! + users.Users?.[key]?.Username}
                user={users.Users[key]}
                isAdd={false}
                companies={companies}
              ></User>
            );
          })}
        </ul>
        <ul>
          <User key="New" user={newUser} isAdd={true} companies={companies}></User>
        </ul>
      </div>
    </AllowedRoles>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    users: state.users,
    companies: state.companies,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    QueryCompanys: () => CompanyDataActions.QueryCompanys()(dispatch),
    QueryUsers: () => UserActions.QueryUsers()(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
